import React from 'react';
import { 
	func, 
	bool 
} from 'prop-types';
import '../../../i18n';
import { withNamespaces,Trans } from 'react-i18next';
import style from './style';

const Presenter = ({
	onClickLogin,
	showSignUp,
	onCLickSignup,
	t,
}) => {
	return (
		<style.Wrapper>
			<style.HeadlineWrapper>
				<style.Headline>
					<style.h2>{t('landing.Welcome')}</style.h2>
				</style.Headline>
				<style.SubHeadline>
					<div>
						<Trans i18nKey="landing.Subheading"
							components={[
								<span key={0} >
                                test
								</span>
							]}
						>
						</Trans>
					</div>
					<style.Mushi2Logo/>
				</style.SubHeadline>
			</style.HeadlineWrapper>
			<style.Content>
				<style.h4>
					<Trans i18nKey="landing.DemoDesctiption"
						values={{ left: '%A{ ', right : ' }', m : ''}}
						components={[
							<b key={0} >
                                test
							</b>, 
							<b key={1} >
                                test
							</b>,
							<b key={2} >
                                test
							</b>,
						]}
					>
					</Trans>
				</style.h4> 
				<style.DemoContent />			
			</style.Content>
			<style.Features>
				<div id='features'>
					<style.Feature>
						<style.ImageWrapper>
							<style.CreateQuizFullLogo/>
						</style.ImageWrapper>
						<style.FeatureText>
							<style.h3> 
								{t('landing.CreateQuizSubheader')}</style.h3>
							<style.p>{t('landing.CreateQuizParagraph1')}</style.p>
						</style.FeatureText>
					</style.Feature>
					<style.Feature>
						<style.ImageWrapper>
							<style.SearchQuizLogo/>
						</style.ImageWrapper>
						<style.FeatureText>
							<style.h3>
								{t('landing.SearchQuizSubheader')}</style.h3>
							<style.p>{t('landing.SearchQuizParagraph1')}</style.p>
						</style.FeatureText>
					</style.Feature>
					<style.Feature>
						<style.ImageWrapper>
							<style.PlayQuizFullLogo/>
						</style.ImageWrapper>
						<style.FeatureText>
							<style.h3>
								{t('landing.PlayQuizSubheader')}</style.h3>
							<style.p>{t('landing.PLayQuizParagraph1')}</style.p>
						</style.FeatureText>
					</style.Feature>
				</div>
			</style.Features>
			<style.StartButtonWrapper>
				<style.FloatingActionButton onClick={onCLickSignup(true)}>
					{t('landing.StartMushiqui')}
				</style.FloatingActionButton>
				<style.Signup
					show={showSignUp}
					onClose={onCLickSignup(false)}
					onLogin={onClickLogin}
					isSignUp
				/>
			</style.StartButtonWrapper>
		</style.Wrapper>
	);
};
	

Presenter.propTypes = {
	onClickLogin : func.isRequired,
	showSignUp : bool.isRequired,
	onCLickSignup : func.isRequired,
	t : func.isRequired
};

export default withNamespaces()(Presenter);